/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Card_Plan_BadgeInputs */

const en_landing_card_plan_badge = /** @type {(inputs: Landing_Card_Plan_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEW`)
};

const id_landing_card_plan_badge = /** @type {(inputs: Landing_Card_Plan_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BARU`)
};

/**
* | output |
* | --- |
* | "NEW" |
*
* @param {Landing_Card_Plan_BadgeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_card_plan_badge = /** @type {((inputs?: Landing_Card_Plan_BadgeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Card_Plan_BadgeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_card_plan_badge(inputs)
	return en_landing_card_plan_badge(inputs)
});